import React, { Component } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import Form, { FormStatus } from "components/forms/Form";
import { Button, Typography } from "@material-ui/core";
import ProgressSpinner from "components/ProgressSpinner";
import "./index.scss";
import { Space } from "services/entities/spaces";
import { loadSpaces } from "services/spaces";
import { BookingSettings } from "services/entities/booking";
import { loadSettings } from "services/pricing";
import { isLoggedIn } from "services/auth";
import { logBookingEnquiry } from "services/contact";
import { handleError } from "util/errors";
import { BookingEnquiryUser } from "services/entities/contact";
import BookingEnquiryUserModal from "../BookingEnquiryUserModal";
import BookingEnquirySuccessModal from "../BookingEnquirySuccessModal";

interface BookingEnquiryModel {
  space: string | null;
}

enum BookingEnquiryModal {
  User,
  Success,
}

interface BookingEnquiryFormState {
  status: FormStatus;
  spaces: Space[] | null;
  bookingSettings: BookingSettings | null;
  modal: BookingEnquiryModal | null;
}

interface BookingEnquiryFormProps extends RouteComponentProps {
  space?: string;
  samplePrice?: number;
}

class BookingEnquiryForm extends Component<
  BookingEnquiryFormProps,
  BookingEnquiryFormState
> {
  private readonly model: BookingEnquiryModel;
  public state: BookingEnquiryFormState = {
    status: FormStatus.Success,
    spaces: null,
    bookingSettings: null,
    modal: null,
  };

  constructor(props: any) {
    super(props);
    this.model = {
      space: null,
    };
  }

  componentDidMount() {
    loadSpaces().then((spaces) => this.setState({ spaces: spaces }));
    loadSettings().then((settings) =>
      this.setState({ bookingSettings: settings })
    );
  }

  onSubmit = () => {
    this.setState({ status: FormStatus.Submitting });
    this.setState({ modal: BookingEnquiryModal.User });
  };

  onFieldInput = () => {
    this.setState({ status: FormStatus.None });
  };

  onUserModalClosing = () => {
    this.setState({ modal: null, status: FormStatus.None });
  };

  onUserSaved = (user: BookingEnquiryUser) => {
    this.setState({ status: FormStatus.Submitting, modal: null });
    this.saveEnquiry(user).then(
      () =>
        this.setState({
          status: FormStatus.Success,
          modal: BookingEnquiryModal.Success,
        }),
      (ex) => {
        handleError("Failed submitting request", ex);
        this.setState({ status: FormStatus.Failure });
      }
    );
  };

  async saveEnquiry(user?: BookingEnquiryUser): Promise<void> {
    const copy = { ...user };
    const space = copy.space!
    if (user && user.space) {
      delete user.space;
    }
    if (isLoggedIn()) {
      return logBookingEnquiry({
        space,
        user: null,
      });
    } else {
      return logBookingEnquiry({
        space,
        user: user || null,
      });
    }
  }

  onSuccessModalClosing = () => {
    this.setState({ modal: null });
  };

  renderForm() {
    const disabled = this.state.status === FormStatus.Submitting;
    return (
      <div className="booking-enquiry-form-wrapper">
        <div className="form-grid content-mw">
          <Form
            className="booking-enquiry-form space-visible"
            onSubmit={this.onSubmit}
          >
            <div className="space">
              {this.props.samplePrice ? (
                <Typography variant="body1" component="p" className="text">
                  Book now from £{this.props.samplePrice} per day.
                </Typography>
              ) : (
                <Typography variant="body1" component="p" className="text">
                  Book your Sook today.
                </Typography>
              )}
            </div>
            <Button
              className="submit"
              type="submit"
              disabled={disabled}
              variant="contained"
            >
              {this.state.status === FormStatus.Submitting && (
                <ProgressSpinner />
              )}
              Check Availability
            </Button>
          </Form>
        </div>
      </div>
    );
  }

  renderUserModal() {
    return (
      <BookingEnquiryUserModal
        spaces={this.state.spaces}
        open={this.state.modal === BookingEnquiryModal.User}
        onCancelled={this.onUserModalClosing}
        onSaved={this.onUserSaved}
        space={this.props.space}
        changeSpace={this.onFieldInput}
      />
    );
  }

  renderSuccessModal() {
    return (
      <BookingEnquirySuccessModal
        open={this.state.modal === BookingEnquiryModal.Success}
        onClosing={this.onSuccessModalClosing}
      />
    );
  }

  render() {
    return (
      <>
        {this.renderForm()}
        {this.renderUserModal()}
        {this.renderSuccessModal()}
      </>
    );
  }
}

export default withRouter(BookingEnquiryForm);
